import store from "../state/store";

import {createWebHistory, createRouter} from "vue-router";
import routes from "./routes";
import qs from 'qs'

const router = createRouter({
    history: createWebHistory(),
    parseQuery: (query) => {
        return qs.parse(query)
    },
    stringifyQuery(query) {
        const result = qs.stringify(query, {encode: false})
        return result || ''
    },
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
});

router.beforeEach((routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some(matched => matched.meta.authRequired);
    const authenticated = store.getters['auth/authenticated'];
    const landing = store.getters['auth/landing'];

    if (!authRequired) {
        if (routeTo.name === 'login' && authenticated && landing) {
            return next(landing);
        }

        return next();
    }

    if (!authenticated) {
        return next({name: 'login', query: {redirectFrom: routeTo.fullPath}});
    }

    // The role belongs to the other front end.
    if (!landing) {
        return next({name: 'login'});
    }

    if (routeTo.path === '/') {
        return next(landing);
    }

    const ability = routeTo.matched.reduce((current, matched) => {
        return matched.meta.ability || current;
    }, null);

    if (ability && !store.getters['auth/can'](ability)) {
        return next(landing);
    }

    next();
});

export default router;
